import React, { FunctionComponent } from 'react';
import { observer } from 'mobx-react';
import Dialog from '~/component/dialog';
import strings from '~/constants/strings';

import { Grid } from '@mui/material';
import medicalCareStore from '~/store/medicalCareStore';
import _ from 'lodash';
import { CloseCircleOutlined } from '@ant-design/icons';
import { WeekSetting } from './WeeklySetting/WeekSetting';
import { SpecialDayList } from './WeeklySetting/SpecialDayList';

const styles = {
  button: {
    minHeight: 40,
    width: 150,
  },
};

type Props = {
  onClose: () => void;
};

export const HoursSettingDialog: FunctionComponent<Props> = observer(
  (props) => {
    const { onClose } = props;
    const { isLoading } = medicalCareStore;

    return (
      <Dialog
        width={950}
        containerClassName={'hours-setting-dialog'}
        title={strings.hours.hoursSetting}
        titleClassName={'posRelative'}
        open
        handleCancel={onClose}
        isLoading={isLoading}
        footer={<div />}
        keyboard={false}
        closeIcon={
          <CloseCircleOutlined
            style={{
              color: '#9a9a9a',
              fontSize: 32,
            }}
            width={32}
            height={32}
          />
        }
      >
        <Grid container flexDirection={'row'} justifyContent={'flex-start'}>
          <WeekSetting onClose={onClose} />
          <SpecialDayList />
        </Grid>
      </Dialog>
    );
  },
);
